// translation.ts
var defaultWikiTranslation = {
  wiki: {
    notPublishedTooltip: ["Noch nicht veroeffentlicht", "Not yet published"],
    notFound: ["Nicht gefunden", "Not found"],
    newEntry: ["Neuer Eintrag", "New entry"],
    draft: ["Entwurf", "Draft"],
    subpages: ["Unterseiten", "Subpages"],
    created: ["Erstellt", "Created"],
    modified: ["Ge\xE4ndert", "Modified"],
    createdMissing: ["Erstellt fehlgeschlagen", "Creation failed"],
    unknownUser: ["Unbekannter Benutzer", "Unknown user"],
    toOriginal: ["Zur urspr\xFCnglichen Seite", "To original page"],
    entrySaved: ["Eintrag gesichert", "Entry saved"],
    entryCreated: ["Eintrag erstellt", "Entry created"],
    leavePreview: ["Vorschau verlassen", "Leave preview"],
    draftList: {
      status: ["Status", "Status"],
      createdOn: ["Erstellt am", "Created on"],
      confirmDelete: ["Wollen Sie diesen Entwurf wirklich l\xF6schen?", "Do you really want to delete this draft?"],
      confirmApply: [
        "Wollen Sie diesen Entwurf wirklich auf das Original \xFCbertragen?",
        "Do you really want to apply this draft to the original?"
      ],
      deleting: ["Wird gel\xF6scht...", "Deleting..."],
      deleted: ["Gel\xF6scht!", "Deleted!"],
      applying: ["Wird \xFCbertragen...", "Applying..."],
      applied: ["\xDCbertragen!", "Applied!"],
      noDrafts: ["Keine Entw\xFCrfe", "No drafts"]
    },
    actions: {
      save: ["Speichern", "Save"],
      create: ["Erstellen", "Create"],
      cancel: ["Abbrechen", "Cancel"],
      createDraft: ["Entwurf erstellen", "Create draft"],
      applyDraft: ["Entwurf anwenden", "Apply draft"],
      confirmApplyDraft: ["Soll der Entwurf wirklich anwendet werden?", "Apply draft?"],
      confirmCancel: ["Soll die Seite wirklich verlassen werden?", "Leave page?"],
      delete: ["L\xF6schen", "Delete"],
      confirmDelete: ["Soll die Seite wirklich gel\xF6scht werden?", "Delete page?"],
      confirmDraftDelete: ["Soll der Entwurf wirklich gel\xF6scht werden?", "Delete draft?"],
      titleRequired: ["Bitte geben Sie einen Titel ein", "Please enter a title"]
    }
  },
  field: {
    title: ["Titel", "Title"],
    parent: ["Parent", "Parent"],
    status: ["Status", "Status"],
    published: ["Ver\xF6ffentlicht", "Published"],
    readPermission: ["Leserechte", "Read permission"],
    writePermission: ["Schreibrechte", "Write permission"],
    createdAt: ["Erstellt", "Created"],
    modifiedAt: ["Ge\xE4ndert", "Modified"],
    wiki: {
      title: ["Titel", "Title"],
      parent: ["Parent", "Parent"],
      status: ["Status", "Status"],
      published: ["Ver\xF6ffentlicht", "Published"],
      readPermission: ["Leserechte", "Read permission"],
      writePermission: ["Schreibrechte", "Write permission"],
      createdAt: ["Erstellt", "Created"],
      modifiedAt: ["Ge\xE4ndert", "Modified"]
    }
  }
};
export {
  defaultWikiTranslation
};
